import { Clipboard } from '@chakra-ui/react';
import { PropsWithChildren } from 'react';
import { RoundedButton } from './rounded-button';
import { ClipboardIcon } from './ui/clipboard';

type CopyTextProps = {
  value: string | undefined;
} & PropsWithChildren;
export const CopyText = ({ value, children }: CopyTextProps) => {
  return (
    <Clipboard.Root value={value}>
      <Clipboard.Trigger asChild>
        <RoundedButton variant="plain" size="xs" px={0} bg="bg" _hover={{ bg: 'bg.subtle' }} color="fg.muted">
          {children}
          <ClipboardIcon />
        </RoundedButton>
      </Clipboard.Trigger>
    </Clipboard.Root>
  );
};
